import { DebugAvailablityVistor } from "./DebugAvailablityVistor";
export function debugAvailabilityErrors(availability) {
    const rootVistor = new DebugAvailablityVistor();
    availability.accept(rootVistor);
    return rootVistor.errors;
}
